import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { LoaderService } from '../../core/loader/loader.service';

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.sass']
})
export class LoaderComponent {
  @Input() delay = 0;
  @Input('showText') showText = false;

  color = 'primary';
  mode = 'indeterminate';
  value = 50;

  isLoading: Observable<boolean>;

  constructor(
    private loaderService: LoaderService,
  ) {
    this.isLoading = this.loaderService.loading().pipe(delay(0));
  }
}
